module.exports = __webpack_public_path__ + "static/media/feature-tick.a331cf89.svg";